import React from "react";
import { Button } from "@capacit-com/lara-law-shared-ui";
import { XIcon } from "lucide-react";
import { useConversationHub } from "@/hooks/useConversationHub";

interface FilterPillProps {
  source: string;
  displayName?: string;
  onRemoveSource: () => void;
  inPopover?: boolean;
  isOverview?: boolean;
  // Optional props for backward compatibility (not used for non-workspace sources)
  pillIndex?: number;
  filters?: Record<string, unknown>;
  dataPillItem?: boolean;
  dataWorkspacePill?: boolean;
}

const FilterPill: React.FC<FilterPillProps> = ({
  source,
  displayName,
  onRemoveSource,
  inPopover = false,
  isOverview = false,
  dataPillItem,
  dataWorkspacePill,
}) => {
  const { selectedConversation } = useConversationHub();

  const handleRemoveFilter = (e: React.MouseEvent) => {
    e.stopPropagation();
    onRemoveSource();
  };

  return (
    <div
      className={`flex items-center space-x-2 px-3 py-1 rounded-sm text-xs border border-primary select-none ${
        selectedConversation || isOverview
          ? "cursor-not-allowed"
          : "cursor-pointer"
      } ${inPopover ? "w-full justify-between" : ""}`}
      {...(dataPillItem && { "data-pill-item": true })}
      {...(dataWorkspacePill && { "data-workspace-pill": true })}
    >
      <div>
        <span className="font-semibold">{displayName || source}</span>
      </div>

      {!selectedConversation && !isOverview && (
        <div className="flex">
          <Button
            onClick={handleRemoveFilter}
            className="text-destructive bg-transparent size-2 cursor-pointer p-2 shadow-none hover:bg-transparent border-transparent border border-dashed hover:border-dashed hover:border hover:border-secondary-foreground hover:text-destructive rounded-md"
            aria-label="Remove source filter"
          >
            <XIcon />
          </Button>
        </div>
      )}
    </div>
  );
};

export default FilterPill;
